module.exports = __webpack_public_path__ + "assets/app/img/oligo-label-sample.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/images/oligo-label-sample.png
// module id = 9l6V
// module chunks = 1